module.exports = __webpack_public_path__ + "static/washing-car-1397382_640-6bbe38c06a0b160c72808aeac9d2da30.jpg";